import React, { useState } from "react";
import { ButtonVariant, Dialog } from "@merge-api/merge-javascript-shared";
import { navigateToWebhooksConfigurationPage } from "../../../../../../router/RouterUtils";
import { useHistory } from "react-router-dom";
import { showErrorToast, showSuccessToast } from "../../../../../shared/Toasts";
import { fetchWithAuth } from "../../../../../../api-client/APIClient";

type Props = {
  open: boolean;
  onClose: () => void;
  webhookID: string;
};

const WebhookDeletionModal = ({ open, onClose, webhookID }: Props) => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);

  const deleteWebhook = (webhookID: string) => {
    setIsLoading(true);
    fetchWithAuth({
      path: "/integrations/webhooks/" + webhookID,
      method: "DELETE",
      onResponse: () => {
        showSuccessToast("Successfully deleted webhook!");
        navigateToWebhooksConfigurationPage(history);
        setIsLoading(false);
      },
      onError: (err: Response | undefined) => {
        if (err && err.status === 403) {
          showErrorToast(
            "Insufficient permissions. Please contact your Merge administrator to access this feature.",
          );
        } else {
          showErrorToast("Something went wrong, please try again.");
        }
        setIsLoading(false);
      },
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      onPrimaryButtonClick={() => deleteWebhook(webhookID)}
      primaryButtonVariant={ButtonVariant.DangerFilled}
      primaryButtonText="Delete webhook"
      primaryButtonLoading={isLoading}
      onSecondaryButtonClick={onClose}
      secondaryButtonText="Cancel"
      title="Delete webhook"
      variant="md"
    >
      <p>This action cannot be undone.</p>

      <p>Do you wish to continue?</p>
    </Dialog>
  );
};

export default WebhookDeletionModal;
